(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bravomen-comunidad"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bravomen-community')) {
    customElements.define('bravomen-community', class extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.viewport = this.querySelector('.bv-community__viewport');
        this.track = this.querySelector('.bv-community__track');
        this.original = this.querySelector('[data-bv-original]');
        this.button = this.querySelector('.bv-community__toggle');
        this.controls = this.querySelector('.bv-community__controls');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.pauses = new Set();
        this.enabled = this.dataset.autoplay === 'true' && this.dataset.editor !== 'true';
        const signal = this.abortController.signal;
        if (!this.original || !this.original.children.length) return;
        this.button?.addEventListener('click', () => {
          if (this.pauses.has('user')) this.pauses.delete('user');
          else this.pauses.add('user');
          this.syncPause();
        }, { signal });
        if (this.dataset.hoverPause === 'true') {
          this.viewport.addEventListener('pointerenter', (event) => {
            if (event.pointerType === 'mouse') { this.pauses.add('hover'); this.syncPause(); }
          }, { signal });
          this.viewport.addEventListener('pointerleave', () => { this.pauses.delete('hover'); this.syncPause(); }, { signal });
        }
        this.viewport.addEventListener('focusin', () => { this.pauses.add('focus'); this.syncPause(); }, { signal });
        this.viewport.addEventListener('focusout', () => { this.pauses.delete('focus'); this.syncPause(); }, { signal });
        this.viewport.addEventListener('scroll', () => {
          if (this.classList.contains('is-animated') && this.groupWidth && this.viewport.scrollLeft >= this.groupWidth) {
            this.viewport.scrollLeft %= this.groupWidth;
          }
        }, { passive: true, signal });
        this.viewport.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0 || !this.classList.contains('is-animated')) return;
          if (event.target.closest('button, a')) return;
          this.drag = { id: event.pointerId, x: event.clientX, scroll: this.viewport.scrollLeft };
          this.viewport.setPointerCapture(event.pointerId);
          this.classList.add('is-dragging');
          this.pauses.add('drag'); this.syncPause();
          event.preventDefault();
        }, { signal });
        this.viewport.addEventListener('pointermove', (event) => {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          this.viewport.scrollLeft = this.drag.scroll + this.drag.x - event.clientX;
        }, { signal });
        const endDrag = () => {
          this.drag = null;
          this.classList.remove('is-dragging');
          this.pauses.delete('drag'); this.syncPause();
        };
        this.viewport.addEventListener('pointerup', endDrag, { signal });
        this.viewport.addEventListener('pointercancel', endDrag, { signal });
        this.viewport.addEventListener('lostpointercapture', endDrag, { signal });
        this.viewport.addEventListener('touchstart', () => { this.pauses.add('touch'); this.syncPause(); }, { passive: true, signal });
        const endTouch = () => {
          clearTimeout(this.touchTimer);
          this.touchTimer = setTimeout(() => { this.pauses.delete('touch'); this.syncPause(); }, 1200);
        };
        this.viewport.addEventListener('touchend', endTouch, { passive: true, signal });
        this.viewport.addEventListener('touchcancel', endTouch, { passive: true, signal });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.pauses.add('hidden'); else this.pauses.delete('hidden');
          this.syncPause();
        }, { signal });
        document.addEventListener('shopify:block:select', (event) => {
          const selected = [...this.original.children].find((item) => item.dataset.bvBlock === event.detail?.blockId);
          if (selected) this.viewport.scrollLeft = selected.offsetLeft - this.original.offsetLeft;
        }, { signal });
        this.motion.addEventListener('change', () => this.rebuild(), { signal });
        this.resizeObserver = new ResizeObserver(() => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => this.rebuild());
        });
        this.resizeObserver.observe(this.viewport);
        this.resizeObserver.observe(this.original);
        this.intersectionObserver = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) this.pauses.delete('offscreen'); else this.pauses.add('offscreen');
          this.syncPause();
        }, { rootMargin: '100px' });
        this.intersectionObserver.observe(this);
        this.rebuild();
        document.fonts?.ready.then(() => { if (this.isConnected) this.rebuild(); });
      }
      rebuild() {
        if (!this.track || !this.original) return;
        this.track.querySelectorAll('[data-bv-copy]').forEach((copy) => copy.remove());
        this.classList.remove('is-animated');
        if (!this.enabled || this.motion.matches || !this.original.children.length) {
          if (this.controls) this.controls.hidden = true;
          return;
        }
        const width = this.original.getBoundingClientRect().width;
        if (!width) return;
        const count = Math.ceil(this.viewport.clientWidth / width) + 1;
        for (let index = 0; index < count; index++) {
          const copy = this.original.cloneNode(true);
          copy.removeAttribute('data-bv-original');
          copy.setAttribute('data-bv-copy', '');
          copy.setAttribute('aria-hidden', 'true');
          copy.setAttribute('inert', '');
          copy.querySelectorAll('*').forEach((node) => {
            node.removeAttribute('id');
            node.removeAttribute('data-bv-block');
            [...node.attributes].forEach((attribute) => {
              if (attribute.name.startsWith('data-shopify')) node.removeAttribute(attribute.name);
            });
          });
          this.track.appendChild(copy);
        }
        this.groupWidth = width;
        this.viewport.scrollLeft %= width;
        this.style.setProperty('--bv-distance', `${width}px`);
        this.style.setProperty('--bv-duration', `${width / Math.max(8, Number(this.dataset.speed) || 24)}s`);
        this.classList.add('is-animated');
        if (this.controls) this.controls.hidden = false;
        this.syncPause();
      }
      syncPause() {
        this.classList.toggle('is-paused', this.pauses.size > 0);
        if (this.button) {
          const userPaused = this.pauses.has('user');
          this.button.setAttribute('aria-pressed', String(userPaused));
          this.button.querySelector('[data-bv-toggle-label]').textContent = userPaused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel;
        }
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        clearTimeout(this.touchTimer);
        cancelAnimationFrame(this.resizeFrame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
